//ProfileSettings.tsx
//import React from "react";
import PushNotificationsModal from "./PushNotificationsModal";
import AccountActivationModal from "./AccountActivationToggleModal";
import { Link } from "react-router-dom";

interface Props {
  pushNotifications: boolean;
  setPushNotifications: (v: boolean) => void;
  accountActive: boolean;
  setAccountActive: (v: boolean) => void;
  cookiePolicyChoice: string;
  setCookiePolicyChoice: (v: string) => void;
  isPushNotificationOpen: boolean;
  setisPushNotificationOpen: (v: boolean) => void;
  isAccountActivationOpen: boolean;
  setisAccountActivationOpen: (v: boolean) => void;
  isCookiesOpen: boolean;
  setCookiesOpen: (v: boolean) => void;
  onDeleteAccountClick: () => void;
}

export default function ProfileSettings({
  pushNotifications,
  setPushNotifications,
  accountActive,
  setAccountActive,
  cookiePolicyChoice,
  setCookiePolicyChoice,
  isPushNotificationOpen,
  setisPushNotificationOpen,
  isAccountActivationOpen,
  setisAccountActivationOpen,
  onDeleteAccountClick,
}: Props) {
  return (
    <section className="font-semibold">
  

      <div className="space-y-4">


        {/* Push Notifications */}
        <div className="flex items-center justify-between py-2">
          <div className="flex items-center text-gray-800">
            <span>Push Notifications</span>
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                setisPushNotificationOpen(true);
              }}
              className="ml-2 text-brand text-xs underline"
            >
              Explain
            </button>
          </div>

          <div className="relative">
            <input
              id="toggle-push"
              type="checkbox"
              className="sr-only peer"
              checked={pushNotifications}
              onChange={(e) => setPushNotifications(e.target.checked)}
            />
            <label
              htmlFor="toggle-push"
              className="block w-11 h-6 rounded-full bg-gray-300 peer-checked:bg-brand transition relative
                         after:content-[''] after:absolute after:top-1 after:left-1 after:h-4 after:w-4
                         after:bg-white after:rounded-full after:transition peer-checked:after:translate-x-5"
            />
          </div>
        </div>

        {/* Account Active */}
        <div className="flex items-center justify-between py-2">
          <div className="flex items-center text-gray-800">
            <span>Account Active</span>
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                setisAccountActivationOpen(true);
              }}
              className="ml-2 text-brand text-xs underline"
            >
              Explain
            </button>
          </div>

          <div className="relative">
            <input
              id="toggle-account"
              type="checkbox"
              className="sr-only peer"
              checked={accountActive}
              onChange={(e) => setAccountActive(e.target.checked)}
            />
            <label
              htmlFor="toggle-account"
              className="block w-11 h-6 rounded-full bg-gray-300 peer-checked:bg-brand transition relative
                         after:content-[''] after:absolute after:top-1 after:left-1 after:h-4 after:w-4
                         after:bg-white after:rounded-full after:transition peer-checked:after:translate-x-5"
            />
          </div>

          {/* Modals */}
          <PushNotificationsModal
            isOpen={isPushNotificationOpen}
            onClose={() => setisPushNotificationOpen(false)}
          />

          <AccountActivationModal
            isOpen={isAccountActivationOpen}
            onClose={() => setisAccountActivationOpen(false)}
          />
        </div>

        {/* Cookie Policy */}
        <div className="pt-2">
          <label className="block text-gray-800 pb-2 mb-1">
            Cookie Policy Choice{" "}
            <Link to="/cookies" target="_blank" className="text-xs pl-1 pb-2 text-brand underline">
              Cookie Policy
            </Link>
          </label>
          
          <select
            value={cookiePolicyChoice}
            onChange={(e) => setCookiePolicyChoice(e.target.value)}
            className="w-full border border-gray-300 rounded-lg p-2 focus:outline-none focus:ring-2 focus:ring-brand/40"
          >
            <option value="">Select Policy</option>
            <option value="strict">Strict</option>
            <option value="moderate">Moderate</option>
            <option value="relaxed">Relaxed</option>
          </select>
          <div className="mt-2">

          </div>

        </div>

        {/* Delete account — placed at the bottom of settings, visually deliberate */}
        <div className="pt-4" style={{ borderTop: '1px solid #e5e7eb', marginTop: 8 }}>
          <button
            type="button"
            onClick={onDeleteAccountClick}
            style={{
              background: 'none',
              border: 'none',
              padding: 0,
              fontFamily: "'Nunito', sans-serif",
              fontSize: 13,
              fontWeight: 600,
              color: '#9B3B22',
              cursor: 'pointer',
              textDecoration: 'underline',
              textUnderlineOffset: 2,
            }}
          >
            Delete my account and all my data
          </button>
        </div>
      </div>
    </section>
  );
}
